import Channel from '../api/channel';
import * as mutation from '../mutations/channel';

const state = {
  channels_max_page: 2,
  channels_total_count: 0,
  channels: [],
  channel: {
    idx: 0,
    title: '',
    introduce: '',
    thumbnail: null,
    subscribe_cnt: 0,
    subscribes: false,
    type: '',
    user: {
      idx: 0, name: '', profile_image: null
    },
  },
  posts_total_count: 0,
  posts_max_page: 2,
  posts: [],
  products_total_count: 0,
  products_max_page: 2,
  products: [], // TODO: key name 재확인
};

const getters = {
  channels_total_count: state => state.channels_total_count,
  channels: state => state.channels,
  channel: state => state.channel,
  ownerIdx: state => state.channel.user.idx,
  posts_total_count: state => state.posts_total_count,
  posts: state => state.posts,
  products_total_count: state => state.products_total_count,
  products: state => state.products,
};

const actions = {
  selectChannels ({ commit }, { second, order, page, hashtag, type }) { // 채널 목록
    if (page <= state.channels_max_page) {
      return Channel.getChannel(second, order, page, hashtag, type).then(response => {
        commit(mutation.SELECT_CHANNELS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectChannel ({ commit }, idx) { // 특정 채널 상세
    return Channel.getChannelIdx(idx).then(response => {
      commit(mutation.SELECT_CHANNEL, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  selectChannelPosts ({ commit }, { channel_idx, second, order, page, hashtag }) { // 특정 채널 포스트 목록
    if (page <= state.posts_max_page) {
      return Channel.getChannelPost(channel_idx, second, order, page, hashtag).then(response => {
        console.log(response);
        commit(mutation.SELECT_CHANNEL_POSTS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  createPost (context, formData) { // 포스트 생성 (피드 only)
    return Channel.postPost(formData);
  },
  toggleSubscription (context, idx) { // 채널 구독 & 구독 취소, 뮤테이션은 별개로 처리
    return Channel.postChannelSubscribe(idx);
  },
  updateChannel (context, { idx, fields }) { // 채널 thumbnail, introduce 수정
    return Channel.patchChannelIdx(idx, fields);
  }
};

const mutations = {
  [mutation.SELECT_CHANNELS] (state, response) {
    state.channels_total_count = response.total_count;
    state.channels_max_page = response.max_page;
    response.req_page === 1 ? state.channels = response.data : state.channels.push(...response.data);
  },
  [mutation.SELECT_CHANNEL] (state, channel) {
    state.channel = channel;
  },
  [mutation.SELECT_CHANNEL_POSTS] (state, response) {
    state.posts_total_count = response.total_count;
    state.posts_max_page = response.max_page;
    response.req_page === 1 ? state.posts = response.data : state.posts.push(...response.data);
  },
  [mutation.TOGGLE_SUBSCRIPTION] (state, { idx, flag }) { // 채널 목록, 채널 상세페이지에서 구독시 뮤테이션
    if (state.channels.length) {
      let target = state.channels.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined') {
        target.subscribes = flag;
        flag ? target.subscribe_cnt++ : target.subscribe_cnt--;
      }
    }
    if (state.channel.idx === idx) {
      state.channel.subscribes = flag;
      flag ? state.channel.subscribe_cnt++ : state.channel.subscribe_cnt--;
    }
  },
  [mutation.TOGGLE_LIKE] (state, { idx, flag }) { // 채널에서
    if (state.posts.length) {
      let target = state.posts.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined' && typeof flag === 'boolean') {
        target.likes = flag;
        flag ? target.like_cnt++ : target.like_cnt--;
      }
    }
  },
  [mutation.TOGGLE_BOOKMARK] (state, { idx, flag }) { // 채널에서
    if (state.posts.length) {
      let target = state.posts.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined') {
        target.bookmarks = flag;
        flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
